import React from 'react';
import { Typography, Container, Box } from '@material-ui/core';
import GoogleSignInButton from './GoogleOAuthButton';
import useAuth from '../../Hooks/useAuth';
import useStyles from './SigninStyle';
import useFeatureToggle from '../../Hooks/useFeatureToggle';
import FormBasedLogin from './FormBasedLogin';
import { FEATURE_FLAGS } from '../../constant/constants';

const Signin = () => {
  const classes = useStyles();
  const { handleGoogleSignin } = useAuth();
  const { isEnabled, hasAuthProvider, isTenantConfigLoaded } = useFeatureToggle();
  const showGoogleLogin =
    hasAuthProvider('google') ||
    (!isTenantConfigLoaded && process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_ID);

  return (
    <Container className={classes.rootContainer} data-testid="signin-container">
      <Box className={classes.formContainer}>
        <Typography component="h1" variant="h4" className={classes.formTitle}>
          Sign In
        </Typography>

        {showGoogleLogin && <GoogleSignInButton onSignIn={handleGoogleSignin} />}

        {(isEnabled(FEATURE_FLAGS.BASIC_AUTHENTICATION) || hasAuthProvider('basic')) && (
          <FormBasedLogin />
        )}

        {!hasAuthProvider('google') &&
          !isEnabled(FEATURE_FLAGS.BASIC_AUTHENTICATION) &&
          !hasAuthProvider('basic') && <FormBasedLogin />}
      </Box>
    </Container>
  );
};

export default Signin;
